<template>
    <div class="max-h-screen h-screen fixed top-0 w-full z-50 overflow-hidden flex flex-col flex-wrap xl:justify-center">
        <BackgroundOverlay />
        <transition name="slide">
            <div
                v-if="show"
                class="bg-white h-full flex flex-col overflow-hidden rounded-t-2xl w-full transition-all duration-500 transform max-w-[672px] mx-auto xl:rounded-b-2xl xl:mt-20 xl:mb-20 xl:h-auto"
            >
                <!-- Top-->
                <div class="h-auto flex py-3 px-4 border-b border-gray-400 items-center">
                    <div class="flex-auto text-center text-[20px] font-medium">
                        {{ title }}
                    </div>
                    <div class="flex justify-end">
                        <button
                            @click="onClose"
                        >
                            <img
                                src="@/assets/images/icons/close.svg"
                                loading="lazy"
                                alt="close"
                            >
                        </button>
                    </div>
                </div>
                <!-- /Top-->
                <!-- preloader-->
                <div v-if="!loaded">
                    <div class="max-w-3xl xl:h-48 mx-auto">
                        <ContentLoader
                            height="100"
                            width="400"
                            view-box="0 0 400 100"
                            background-color="#d9d9d9"
                            foreground-color="#ecebeb"
                        >
                            <rect
                                x="15"
                                y="15"
                                rx="4"
                                ry="4"
                                width="130"
                                height="10"
                            />
                            <rect
                                x="155"
                                y="15"
                                rx="3"
                                ry="3"
                                width="130"
                                height="10"
                            />
                            <rect
                                x="295"
                                y="15"
                                rx="3"
                                ry="3"
                                width="90"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="40"
                                rx="3"
                                ry="3"
                                width="90"
                                height="10"
                            />
                            <rect
                                x="115"
                                y="40"
                                rx="3"
                                ry="3"
                                width="60"
                                height="10"
                            />
                            <rect
                                x="185"
                                y="40"
                                rx="3"
                                ry="3"
                                width="200"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="65"
                                rx="3"
                                ry="3"
                                width="130"
                                height="10"
                            />
                            <rect
                                x="160"
                                y="65"
                                rx="3"
                                ry="3"
                                width="120"
                                height="10"
                            />
                            <rect
                                x="290"
                                y="65"
                                rx="3"
                                ry="3"
                                width="95"
                                height="10"
                            />
                            <rect
                                x="15"
                                y="90"
                                rx="3"
                                ry="3"
                                width="130"
                                height="10"
                            />
                            <rect
                                x="160"
                                y="90"
                                rx="3"
                                ry="3"
                                width="225"
                                height="10"
                            />
                        </ContentLoader>
                    </div>
                </div>
                <!-- /preloader-->
                <div class="flex-1 overflow-hidden flex flex-col pt-2 pb-4 px-1">
                    <div
                        v-if="hasContent"
                        class="pt-4 pb-28 px-6 overflow-y-scroll flex-1 xl:pb-6"
                    >
                        <div class="text-[18px] text-blue-700 font-medium text-center mt-4">
                            {{ insName }}
                        </div>
                        <div
                            v-if="policyTermsUrl"
                            class="text-center mt-3"
                        >
                            <a
                                :href="`${policyTermsUrl}`"
                                target="_blank"
                            >
                                <IconSearchFile class="w-6 inline-block mr-1" />
                                <span class="text-blue underline"> 保單條款</span>
                            </a>
                        </div>
                        <div class="max-w-2xl mx-auto border border-gray-600 mt-4 rounded-2xl term-table">
                            <div
                                v-if="guarantor"
                                class="p-4"
                            >
                                <div class="text-[16px] font-medium border-gray-600">
                                    保障對象
                                </div>
                                <div
                                    class="mt-2"
                                    v-html="cleanHtml(guarantor)"
                                >
                                </div>
                            </div>

                            <div
                                v-if="coverage"
                                class="p-4 border-t border-gray-600"
                            >
                                <div class="text-[16px] font-medium">
                                    保障範圍
                                </div>
                                <div
                                    class="mt-2"
                                    v-html="cleanHtml(coverage)"
                                >
                                </div>
                            </div>

                            <div
                                v-if="description"
                                class="p-4 border-t border-gray-600"
                            >
                                <div class="text-[16px] font-medium">
                                    保障說明
                                </div>
                                <div
                                    class="mt-2"
                                    v-html="cleanHtml(description)"
                                >
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="hint"
                            class="mt-6 max-w-2xl mx-auto px-4"
                        >
                            <div class="mt-5 w-full flex gap-x-2 items-start xl:mx-auto">
                                <div class="mt-0.5 shrink-0">
                                    <img
                                        src="@/assets/images/icons/bell.svg"
                                        loading="lazy"
                                        alt="bell"
                                        class="w-[20px]"
                                    >
                                </div>
                                <div class="flex-1">
                                    溫馨提示：
                                </div>
                            </div>
                            <div
                                class="mt-2"
                                v-html="cleanHtml(hint)"
                            ></div>
                        </div>
                        <div
                            v-if="checkMoreUrl"
                            class="text-center mt-4"
                        >
                            <a
                                :href="checkMoreUrl"
                                target="_blank"
                                class="text-blue underline"
                            >查看更多</a>
                        </div>
                    </div>
                    <div
                        v-else
                        class="p-6 text-center"
                    >
                        {{ errorMessage }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import BackgroundOverlay from '@/components/BackgroundOverlay';
import IconSearchFile from '@/components/icons/SearchFile';
import { ContentLoader } from 'vue-content-loader';
/**
 *  彈跳視窗-險種介紹
 */
export default {
    name: 'InsuranceInfo',
    components: {
        IconSearchFile,
        BackgroundOverlay,
        ContentLoader
    },
    props: {
        /**
         * 險別
         */
        insCategory: {
            type: String,
            default: 'Car'
        },
        /**
         * true = 險種, false = 類別
         */
        isItem: {
            type: Boolean,
            default: true
        },
        /**
         * 險種
         */
        insType: {
            type: String,
            default: null
        },
        /**
         * 彈跳視窗標題
         */
        title: {
            type: String,
            default: '險種介紹'
        }
    },
    emits: ['close'],
    data() {
        /**
         *  接收 API-Insures 回傳的資料
         *  @param {String} insName 保險類別
         *  @param {String} policyTermsUrl 保單條款
         *  @param {String} guarantor 保障對象
         *  @param {String} coverage 保障範圍
         *  @param {String} hint 溫馨提示
         *  @param {String} description 保障說明
         *  @param {String} checkMoreUrl 查看更多連結
         *  @param {Boolean} show 顯示視窗
         *  @param {Boolean} loaded 判斷資料是否載入完成
         *  @param {String} errorMessage 打 API 失敗，前端給錯誤訊息
         */
        return {
            insName: null,
            policyTermsUrl: null,
            guarantor: null,
            coverage: null,
            hint: null,
            loaded: false,
            errorMessage: null,
            description: null,
            checkMoreUrl: null,
            show: true,
        };
    },
    computed: {
        /**
         * 用於判斷是否載入內容
         * 
         * @returns {Boolean} 判斷資料是否載入並沒有錯誤訊息
         */
        hasContent() {
            return this.loaded && !this.errorMessage;
        }
    },
    mounted() {
        // 使 body 元素的內容禁止滾動，彈跳視窗顯示時，防止使用者通過滾動背景頁面造成網頁重新整理
        document.body.classList.add('overflow-hidden');
        const request = {
            InsCategory: this.$route.params.type === 'car'? 'Car' : 'Motorcycle'
        };

        request.InsType = this.insType;
        request.IsItem = this.isItem;

        // 載入 API-Insures 的資料
        axios.post(apiUrl.Insures, request).then(res => {

            if (res.data.Code === 200) {
                this.insName = res.data.Data.InsuresInformation.InsName;
                this.policyTermsUrl = res.data.Data.InsuresInformation.PolicyTermsUrl;
                this.guarantor = res.data.Data.InsuresInformation.Guarantor ? res.data.Data.InsuresInformation.Guarantor.replace(/<p><\/p>/g, '') : null;
                this.coverage = res.data.Data.InsuresInformation.Coverage ? res.data.Data.InsuresInformation.Coverage.replace(/<p><\/p>/g, '') : null;
                this.hint = res.data.Data.InsuresInformation.Hint ? res.data.Data.InsuresInformation.Hint.replace(/<p><\/p>/g, '') : null;
                this.description = res.data.Data.InsuresInformation.Description ? res.data.Data.InsuresInformation.Description.replace(/<p><\/p>/g, '') : null;
                this.checkMoreUrl =  res.data.Data.InsuresInformation.CheckMoreUrl;
            } else {
                this.errorMessage = res.data.ErrMessage;
            }
        }).catch(() => {
            this.errorMessage = 'NO DATA';
        }).then(() => {
            this.loaded = true;
        });
    },
    beforeUnmount() {
        // 使 body 元素的內容允許滾動
        document.body.classList.remove('overflow-hidden');
    },
    methods: {
        /**
         * 使用 DOMPurify 將傳入的 html 進行字串的清理，防止 XSS 攻擊
         *
         * @param {String} html 由 API-MostPopularCombination 回傳的每個熱門車險組合的 html 格式
         * @returns {String} 回傳處理過的 HTML 字串
         * @public
         */
        cleanHtml(html) {
            return DOMPurify.sanitize(html);
        },
        /**
         *  關閉彈跳視窗
         * 
         *  @public
         */
        onClose() {
            /**
             *  關閉彈跳視窗
             */
            this.$emit('close');
        }
    }
};
</script>
<style scoped>
.term-table>div:first-child  {
    @apply border-t-0;
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #005BAC;
}

::-webkit-scrollbar-track {
    box-shadow: transparent;
}
</style>
